module.exports = __webpack_public_path__ + "img/icon_warning.fcffe65d.svg";